"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2557],{

/***/ 46524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ContentDownload; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@contentful/rich-text-types/dist/index.js
var dist = __webpack_require__(82562);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/FooterCompact/index.ts + 2 modules
var FooterCompact = __webpack_require__(69524);
// EXTERNAL MODULE: ../../libs/templates/Forms/EmailCaptureForm/index.ts + 3 modules
var EmailCaptureForm = __webpack_require__(41948);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/index.ts + 1 modules
var LogoTiles = __webpack_require__(20442);
// EXTERNAL MODULE: ../../libs/templates/NavigationBrand/index.ts + 3 modules
var NavigationBrand = __webpack_require__(22761);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/LogoTiles.views.tsx
var LogoTiles_views = __webpack_require__(2432);
// EXTERNAL MODULE: ./src/views/Template/shared/utils.tsx
var utils = __webpack_require__(47966);
// EXTERNAL MODULE: ../../libs/next-shared/404/index.ts + 2 modules
var _404 = __webpack_require__(96827);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ./src/views/Template/shared/assets/OgDefault.jpeg
var OgDefault = __webpack_require__(31629);
var OgDefault_default = /*#__PURE__*/__webpack_require__.n(OgDefault);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/Button.tsx
var Button = __webpack_require__(62073);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/matcha/recipes/RichText/index.ts
var RichText = __webpack_require__(47756);
// EXTERNAL MODULE: ../../libs/utils/useScrollToAnchor/useScrollToAnchor.tsx
var useScrollToAnchor = __webpack_require__(83390);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/Template/ContentDownloadPage/components/Hero/HeroImage.tsx





var HeroImage = function HeroImage(_ref) {
  var src = _ref.src,
      alt = _ref.alt,
      width = _ref.width,
      height = _ref.height;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Picture, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      src: src
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Image */.Ee, {
      width: width,
      height: height,
      src: src,
      alt: alt
    })]
  });
};

var Picture = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("picture",  true ? {
  target: "ehlw0u80"
} : 0)( true ? "" : 0);

/* harmony default export */ var Hero_HeroImage = (HeroImage);
;// CONCATENATED MODULE: ./src/views/Template/ContentDownloadPage/components/Hero/breakpoints.ts
var headingCharacterLimitBreakpoints = new Map([[60, "h2"], [0, "h2"]]);
var descriptionCharacterLimitBreakpoints = new Map([[500, "pSmall"], [370, "pMedium"], [0, "pLarge"]]);
var paragraphCharacterLimitBreakpoints = new Map([[370, "pMedium"], [0, "pLarge"]]);
;// CONCATENATED MODULE: ./src/views/Template/ContentDownloadPage/components/Hero/Hero.tsx



function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var CONTENT_DOWNLOAD_HERO_ID = "content-download-hero";
var BLANK_RICH_TEXT = {
  nodeType: dist.BLOCKS.DOCUMENT,
  data: {},
  content: [{
    nodeType: "paragraph",
    data: {},
    content: [{
      nodeType: "text",
      value: "",
      marks: [],
      data: {}
    }]
  }]
};

var Hero = function Hero(_ref) {
  var _renderNode;

  var overline = _ref.overline,
      _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? "" : _ref$heading,
      description = _ref.description,
      image = _ref.image,
      children = _ref.children;
  var richTextDescription = description ? description : BLANK_RICH_TEXT;
  var headingVariant = (0,react.useMemo)(function () {
    return (0,utils/* getFontSizeVariant */.Kc)(heading, headingCharacterLimitBreakpoints);
  }, [heading]);
  var paragraphVariant = (0,react.useMemo)(function () {
    return (0,utils/* getRichTextFontSizeVariant */.VI)(richTextDescription, paragraphCharacterLimitBreakpoints);
  }, [richTextDescription]);
  var options = {
    renderNode: (_renderNode = {}, (0,defineProperty/* default */.Z)(_renderNode, dist.BLOCKS.PARAGRAPH, function (_node, children) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledColoredTypography, {
        variant: paragraphVariant,
        tag: "p",
        children: children
      });
    }), (0,defineProperty/* default */.Z)(_renderNode, dist.BLOCKS.UL_LIST, function (_node, children) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledList, {
        children: children
      });
    }), _renderNode)
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    id: CONTENT_DOWNLOAD_HERO_ID,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHeroRecipeBase, {
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            children: overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h1",
            variant: headingVariant,
            children: heading
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Form */.l0, {
          children: children
        })]
      }), image && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHeroRecipeContents, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_HeroImage, {
          src: image.src,
          alt: image.title,
          height: image.height,
          width: image.width
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledRichText, {
          data: description,
          options: options
        })]
      })]
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "emyz6mr5"
} : 0)("background:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.green[10];
}, ";" + ( true ? "" : 0));

var StyledHeroRecipeBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* default */.ZP,  true ? {
  target: "emyz6mr4"
} : 0)(recipes_Hero/* Wrapper */.im, "{align-items:flex-start;}" + ( true ? "" : 0));

var StyledRichText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(RichText/* default */.ZP,  true ? {
  target: "emyz6mr3"
} : 0)( true ? {
  name: "1d0nbku",
  styles: "margin-top:24px"
} : 0);

var StyledHeroRecipeContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* Contents */.AU,  true ? {
  target: "emyz6mr2"
} : 0)( true ? {
  name: "xrpaxp",
  styles: "justify-items:left"
} : 0);

var StyledColoredTypography = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(RichText/* ColoredTypography */.nq,  true ? {
  target: "emyz6mr1"
} : 0)( true ? {
  name: "1l0p3iw",
  styles: "white-space:pre-line"
} : 0);

var StyledList = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(RichText/* List */.aV,  true ? {
  target: "emyz6mr0"
} : 0)( true ? {
  name: "1flj9lk",
  styles: "text-align:left"
} : 0);

/* harmony default export */ var Hero_Hero = (Hero);
;// CONCATENATED MODULE: ./src/views/Template/ContentDownloadPage/components/ContentSection/ContentSection.tsx



function ContentSection_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var options = {
  renderNode: (0,defineProperty/* default */.Z)({}, dist.BLOCKS.PARAGRAPH, function (node, children) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentSection_StyledColoredTypography, {
      variant: "pLarge",
      tag: "p",
      children: children
    });
  })
};

var ContentSection = function ContentSection(_ref) {
  var heading = _ref.heading,
      description = _ref.description,
      buttonText = _ref.buttonText;
  var scroll = (0,useScrollToAnchor/* default */.Z)(CONTENT_DOWNLOAD_HERO_ID);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* default */.ZP, {
    variant: "noCopy",
    reverse: true,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSectionContents, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
        centered: false,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "h2",
          tag: "h2",
          children: heading
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText/* default */.ZP, {
        data: description,
        options: options
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
          color: "primary",
          variant: "filled",
          size: "large",
          onClick: function onClick() {
            return scroll();
          },
          children: buttonText
        })
      })]
    })
  });
};

var ContentSection_StyledColoredTypography = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(RichText/* ColoredTypography */.nq,  true ? {
  target: "ej1t8p92"
} : 0)( true ? {
  name: "1l0p3iw",
  styles: "white-space:pre-line"
} : 0);

var StyledSectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "ej1t8p91"
} : 0)( true ? {
  name: "z9xs2w",
  styles: "max-width:844px;margin:0 auto"
} : 0);

var ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ej1t8p90"
} : 0)( true ? {
  name: "zck8o6",
  styles: "margin-top:56px;width:100%;text-align:center"
} : 0);

/* harmony default export */ var ContentSection_ContentSection = (ContentSection);
;// CONCATENATED MODULE: ./src/views/Template/ContentDownloadPage/components/ContentDownload.tsx


function ContentDownload_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



















var CONFIRMATION_PAGE_BASE_PATH =  false ? 0 : "/learn/download/thank-you";
var disclaimer = {
  data: {},
  content: [{
    data: {},
    content: [{
      data: {},
      marks: [],
      value: "We'll share a copy of this downloadable content and send you updates about Segment\u2019s products as we continue to build the world\u2019s leading CDP. We use your information according to our ",
      nodeType: "text"
    }, {
      data: {
        uri: "https://www.twilio.com/legal/privacy/"
      },
      content: [{
        data: {},
        marks: [],
        value: "privacy policy",
        nodeType: "text"
      }],
      nodeType: dist.INLINES.HYPERLINK
    }, {
      data: {},
      marks: [],
      value: ". You can update your preferences at any time. ",
      nodeType: "text"
    }],
    nodeType: dist.BLOCKS.PARAGRAPH
  }],
  nodeType: dist.BLOCKS.DOCUMENT
};

var ContentDownloadView = function ContentDownloadView(_ref) {
  var _seo$ogImage;

  var data = _ref.data;
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var router = (0,next_router.useRouter)();
  if (!data) return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_404/* default */.Z, {});
  var hero = data.hero,
      seo = data.seo,
      section = data.section,
      cta = data.cta;
  var sectionDescriptionNumChars = (0,react.useMemo)(function () {
    return (0,utils/* getNumCharactersFromRichText */.Pd)(section.description.content);
  }, [section.description.content]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: seo.pageTitle,
      pageDescription: seo.pageDescription,
      pageOG: ((_seo$ogImage = seo.ogImage) === null || _seo$ogImage === void 0 ? void 0 : _seo$ogImage.src) || (OgDefault_default()),
      themeColor: theme.palette.neutrals.white[100],
      bodyBackground: theme.palette.neutrals.white[100],
      pageRobotsDirective: seo.robotsDirective,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationBrand/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {
        overline: hero.overline,
        heading: hero.heading,
        description: hero.underImageText,
        image: hero.image,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmailCaptureForm/* default */.Z, {
          buttonText: cta.buttonText,
          customFormIdentifier: cta.customFormId,
          loadingSuccess: true,
          customDisclaimer: disclaimer,
          additionalTrackEvent: "Content Downloaded",
          onSubmit: function onSubmit() {
            router.push("".concat(CONFIRMATION_PAGE_BASE_PATH, "/").concat(cta.confirmationPagePath));
          },
          enableJobTitleField: true
        })
      }), sectionDescriptionNumChars > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Main, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentSection_ContentSection, {
          heading: section.heading,
          description: section.description,
          buttonText: cta.buttonText
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoWrapper, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles/* default */.Z, {})
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterCompact/* default */.Z, {})]
    })
  });
};

/* harmony default export */ var ContentDownload = (ContentDownloadView);

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e1g98osb1"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);

var LogoWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1g98osb0"
} : 0)("background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.gray[10];
}, ";", LogoTiles_views/* TilesGridWrapper */.W, "{max-width:100%;}" + ( true ? "" : 0));

/***/ }),

/***/ 47966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AS": function() { return /* binding */ toLogos; },
/* harmony export */   "Kc": function() { return /* binding */ getFontSizeVariant; },
/* harmony export */   "Pd": function() { return /* binding */ getNumCharactersFromRichText; },
/* harmony export */   "VI": function() { return /* binding */ getRichTextFontSizeVariant; }
/* harmony export */ });
/* unused harmony export RichTextCharacterLimitType */
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95235);
/* harmony import */ var lodash_kebabCase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79857);
/* harmony import */ var lodash_kebabCase__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_kebabCase__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_camelCase__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96009);
/* harmony import */ var lodash_camelCase__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_camelCase__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _segment_matcha_components_CompanyLogos_utils_createCompanyLogosComponent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89998);
/* harmony import */ var _TemplateImage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12117);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52903);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var toLogos = function toLogos(logos) {
  return logos.map(function (logo) {
    return {
      id: lodash_kebabCase__WEBPACK_IMPORTED_MODULE_0___default()(logo.title || ""),
      width: logo.width || 0,
      height: logo.height || 0,
      icon: (0,_segment_matcha_components_CompanyLogos_utils_createCompanyLogosComponent__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_TemplateImage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, _objectSpread({}, logo), logo.title), "".concat(lodash_camelCase__WEBPACK_IMPORTED_MODULE_1___default()(logo.title), "Logo"), "Company")
    };
  });
};
var getFontSizeVariant = function getFontSizeVariant(content, breakpoints) {
  var characterCount = content.length;
  var breakpoint = Array.from(breakpoints.keys()).find(function (key) {
    return characterCount > key;
  }) || 0;
  return breakpoints.get(breakpoint) || "pLarge";
};
var RichTextCharacterLimitType;

(function (RichTextCharacterLimitType) {
  RichTextCharacterLimitType["PARAGRAPH"] = "p";
  RichTextCharacterLimitType["LIST"] = "ul";
})(RichTextCharacterLimitType || (RichTextCharacterLimitType = {}));

var getNumCharactersFromRichText = function getNumCharactersFromRichText(richTextContent) {
  var characterCount = 0;
  richTextContent.forEach(function (item) {
    if (item.nodeType === "text") {
      var _ref = item,
          value = _ref.value;
      characterCount += value.length;
    } else if (Array.isArray(item.content)) {
      characterCount += getNumCharactersFromRichText(item.content);
    }
  });
  return characterCount;
};
var getRichTextFontSizeVariant = function getRichTextFontSizeVariant(richText, breakpoints) {
  var characterCount = getNumCharactersFromRichText(richText.content);
  var breakpoint = Array.from(breakpoints.keys()).find(function (key) {
    return characterCount > key;
  }) || 0;
  return breakpoints.get(breakpoint) || "pLarge";
};

/***/ }),

/***/ 89998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createCompanyLogosComponent; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(81333);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/CompanyLogos/wrappers/CompanyLogosWrapper.tsx



var _excluded = ["children"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}



var CompaniesLogosWrapper = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, _objectSpread(_objectSpread({
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ebe1470"
} : 0)( true ? {
  name: "9cyvhp",
  styles: "display:inline-block;svg{max-width:100%;}"
} : 0);
/* harmony default export */ var CompanyLogosWrapper = (CompaniesLogosWrapper);
;// CONCATENATED MODULE: ../../libs/matcha/components/CompanyLogos/wrappers/CompanyMonoLogosWrapper.tsx



var CompanyMonoLogosWrapper_excluded = ["children", "color"];

function CompanyMonoLogosWrapper_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function CompanyMonoLogosWrapper_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? CompanyMonoLogosWrapper_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CompanyMonoLogosWrapper_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}



var CompaniesMonoLogosWrapper = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      color = _ref.color,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, CompanyMonoLogosWrapper_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMonoLogosWrapper_Wrapper, CompanyMonoLogosWrapper_objectSpread(CompanyMonoLogosWrapper_objectSpread({
    ref: ref,
    color: color
  }, rest), {}, {
    children: children
  }));
});
var CompanyMonoLogosWrapper_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e48gjyf0"
} : 0)("display:inline-block;svg{max-width:100%;path[fill='none'],path:not([fill]){fill:", function (_ref2) {
  var color = _ref2.color;
  return color ? color : "currentColor";
}, ";}}" + ( true ? "" : 0));
/* harmony default export */ var CompanyMonoLogosWrapper = (CompaniesMonoLogosWrapper);
;// CONCATENATED MODULE: ../../libs/matcha/components/CompanyLogos/utils/createCompanyLogosComponent.tsx



var createCompanyLogosComponent_excluded = ["children"];

function createCompanyLogosComponent_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function createCompanyLogosComponent_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? createCompanyLogosComponent_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : createCompanyLogosComponent_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}





var wrapperComponents = {
  Company: CompanyLogosWrapper,
  CompanyMono: CompanyMonoLogosWrapper
};
var urlIdRegex = /url\(#(.*)\)/;
var possibleUrlProps = ["href", "fill", "stroke", "filter", "clip-path", "mask", "marker-start", "marker-mid", "marker-end"];
/**
 * This function is used to recursively replace the id prop of the children of the SVG element.
 * It also updates any references to the old id like `url(#some-id)`.
 * This is necessary because the SVG element can be used multiple times on the same page
 * resulting in multiple elements with the same id.
 *
 * NOTE: This is a recursive function and it might result in a stack overflow if the SVG element is too deep.
 */

var recursivelySufixIdProp = function recursivelySufixIdProp(path, id) {
  if (! /*#__PURE__*/(0,react.isValidElement)(path)) {
    return path;
  }

  var uniqueIdProps = Object.fromEntries(Object.entries(path.props).filter(function (_ref) {
    var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 1),
        key = _ref2[0];

    return ["id", "children"].concat(possibleUrlProps).includes(key);
  }));

  if (uniqueIdProps.id) {
    uniqueIdProps.id = "".concat(uniqueIdProps.id, "-").concat(id);
  }

  var _iterator = _createForOfIteratorHelper(possibleUrlProps),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var prop = _step.value;
      var propValue = uniqueIdProps[prop];

      if (typeof propValue === "string" && propValue.match(urlIdRegex)) {
        // Add suffix to the id reference
        uniqueIdProps[prop] = propValue.replace(urlIdRegex, "url(#$1-".concat(id, ")"));
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (uniqueIdProps.children) {
    // Recursively update the children
    uniqueIdProps.children = react.Children.map(uniqueIdProps.children, function (child) {
      return recursivelySufixIdProp(child, id);
    });
  }

  return /*#__PURE__*/(0,react.cloneElement)(path, uniqueIdProps);
};

var createSvgComponent = function createSvgComponent(path, displayName, type) {
  var Wrapper = wrapperComponents[type];

  var Component = function Component(_ref3, ref) {
    var children = _ref3.children,
        rest = (0,objectWithoutProperties/* default */.Z)(_ref3, createCompanyLogosComponent_excluded);

    var id = (0,react.useId)();
    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, createCompanyLogosComponent_objectSpread(createCompanyLogosComponent_objectSpread({
      ref: ref,
      "aria-hidden": "true",
      "data-testid": "customerLogos[".concat(displayName, "]")
    }, rest), {}, {
      children: [recursivelySufixIdProp(path, id), children]
    }));
  };

  if (false) {}

  return /*#__PURE__*/(0,react.memo)( /*#__PURE__*/(0,react.forwardRef)(Component));
};

/* harmony default export */ var createCompanyLogosComponent = (createSvgComponent);

/***/ }),

/***/ 85807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useInView; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useInView/useInView.ts

/**
 * A hook to observe elements in the viewport
 * @param ref - A ref to the element to observe
 * @param options - The options for the IntersectionObserver
 * @returns A boolean indicating if the element is in the viewport
 */

var useIsInView = function useIsInView(ref) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$stopOnIntersecti = _ref.stopOnIntersection,
      stopOnIntersection = _ref$stopOnIntersecti === void 0 ? true : _ref$stopOnIntersecti,
      options = _ref.options;

  var _useState = (0,react.useState)(false),
      isInView = _useState[0],
      setIsInView = _useState[1];

  var inViewRef = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    var intersectionObserver = new IntersectionObserver(function (intersection) {
      if (intersection.some(function (i) {
        return i.isIntersecting;
      })) {
        inViewRef.current = true;
        setIsInView(true);

        if (stopOnIntersection) {
          intersectionObserver.disconnect();
        }
      } else if (inViewRef.current) {
        inViewRef.current = false;
        setIsInView(false);
      }
    }, options);

    if (ref.current) {
      intersectionObserver.observe(ref.current);
    }

    return function () {
      intersectionObserver.disconnect();
    };
  }, [ref]);
  return isInView;
};

/* harmony default export */ var useInView = (useIsInView);
;// CONCATENATED MODULE: ../../libs/utils/useInView/index.ts


/***/ })

}]);